function keepTrying(fn: () => boolean | undefined, times: number, interval: number) {
	if (!fn() && times) setTimeout(() => keepTrying(fn, times - 1, interval), interval);
}

function waitForDom(itemId: string) {
	return new Promise((resolve) => {
		function lookForItem() {
			// eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
			const targetItem = document.querySelector(itemId);
			if (targetItem) {
				clearInterval(checkInterval);
				resolve(true);
			}
		}
		// Start an interval to check for the item every 10ms
		const checkInterval = setInterval(lookForItem, 10);
		// Fail silently if the item isn't found after 5000ms
		setTimeout(() => {
			clearInterval(checkInterval);
			resolve(false);
		}, 5000);
	});
}

function isForgeModule(itemId: string) {
	return itemId.startsWith('ari:cloud:ecosystem::extension');
}

function escapeForgeModuleKey(itemId: string) {
	return itemId.replace(/\//g, '\\/').replace(/:/g, '\\:');
}

function getItemSelector(itemId: string | null | undefined) {
	if (!itemId || !itemId.length) {
		return;
	}

	let itemSelector = itemId[0] === '#' ? itemId : `#${itemId}`;

	if (isForgeModule(itemId)) {
		itemSelector = escapeForgeModuleKey(itemSelector);
	}

	return itemSelector;
}

export async function openForgeAppFromSubmenu({
	parentmenuId,
	submenuId,
	forgeItemId,
}: {
	parentmenuId: string;
	submenuId: string;
	forgeItemId: string;
}): Promise<void> {
	// Make sure the forge item has a valid id
	const forgeItemSelector = getItemSelector(forgeItemId);
	if (!forgeItemSelector) {
		return;
	}

	openMenu(parentmenuId);
	const foundSubmenu = await waitForDom(submenuId);
	if (!foundSubmenu) {
		return;
	}

	openMenu(submenuId);
	const foundForgeItem = await waitForDom(forgeItemSelector);
	if (!foundForgeItem) {
		return;
	}

	// eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
	const forgeItem = document.querySelector(forgeItemSelector) as HTMLElement;
	forgeItem?.click();
}

function openMenu(menuId: string) {
	// eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
	const triggerButton = document.querySelector(menuId) as HTMLElement;
	if (!triggerButton) {
		return;
	}

	const isOpen = triggerButton.getAttribute('aria-expanded') === 'true';

	//only care about closed case, otherwise let legacy event listener handle
	if (!isOpen) {
		triggerButton.click();
	}
}

export function simulateItemClick(itemId: string): void {
	const itemSelector = getItemSelector(itemId);
	if (!itemSelector) {
		return;
	}

	keepTrying(
		() => {
			// eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
			const item = document.querySelector(itemSelector) as HTMLElement;
			if (item) {
				item.click();
				return true;
			}
		},
		100,
		5,
	);
}

export function simulateItemMouseOver(itemId: string): void {
	const itemSelector = getItemSelector(itemId);
	if (!itemSelector) {
		return;
	}

	const event = new MouseEvent('mouseup', { bubbles: true, cancelable: true });
	// eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
	document.querySelector(itemSelector)?.dispatchEvent(event);
}

export function openMenuClick(): void {
	openMenu('#tools-menu-trigger');
}

export function openContextMenuClick(): void {
	openMenu('#context-menu-other-apps');
}

export function openMoreActionsMenuClick(): void {
	openMenu('#more-actions-trigger');
}
